import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ChannelPartner = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 font-sans overflow-hidden">
      {/* Header */}
      {/* <div className="w-screen h-64 md:h-[600px] border-[3px] border-[#35A93E]">
        <img
          src="/channel-partner.jpeg"
          alt="Channel Partner Banner"
          className="w-full h-full object-contain md:object-cover"
        />
      </div> */}

      {/* Main Content */}
      <main className="container mx-auto px-4 py-12">
        {/* Hero Section */}
        <section className="bg-white rounded-2xl shadow-xl p-8 mb-10 text-center transform hover:scale-[1.01] transition-transform duration-300">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Become a Channel Partner of LifeOnPlus
          </h2>
          <p className="text-gray-600 leading-relaxed max-w-2xl mx-auto">
            Bring Digital Healthcare Access to Every Corner of India with the
            LifeOnPlus Global Digital Health Smart Card.
          </p>
          <a
            onClick={() =>
              navigate("/", { state: { openChannelPartnerSignUp: true } })
            }
            className="mt-6 inline-block bg-[#35A93E] text-white font-semibold px-8 py-3 rounded-full hover:bg-green-700 transition-colors duration-300"
          >
            Join as a Channel Partner
          </a>
        </section>

        {/* About LifeOnPlus Section */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
            About LifeOnPlus
          </h2>
          <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
            <p className="text-gray-600 leading-relaxed">
              LifeOnPlus is a powerful digital health platform connecting
              individuals with comprehensive healthcare, wellness, and
              preventive services. Backed by AI, advanced technologies, and
              global health partnerships, LifeOnPlus makes affordable,
              accessible healthcare a reality for everyone—anytime, anywhere.
            </p>
          </div>
        </section>

        {/* Global Digital Health Smart Card Section */}
        <section className="bg-gradient-to-r from-[#35A93E] to-green-500 text-white rounded-2xl shadow-xl p-8 mb-10">
          <h2 className="text-3xl font-bold mb-6 text-center">
            Digital Emergency Health Kit
          </h2>
          <p className="text-center mb-6 leading-relaxed max-w-2xl mx-auto">
            Your Health Identity. Just a Scan Away. A life-saving companion with
            a unique QR code, offering secure access to health data, emergency
            support, preventive wellness, and health discounts.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-xl font-semibold mb-2">
                QR Code/NFC enabled- Health Identity
              </div>
              <p className="text-sm">
                Personalized, secure health profile accessible instantly.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold mb-2">
                Emergency Support Access
              </div>
              <p className="text-sm">
                Shares critical health info: blood group, allergies,
                medications, doctor, and emergency contacts.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold mb-2">Panic Button</div>
              <p className="text-sm">
                Sends real-time alerts with GPS location with call to nearby
                ambulance, police, and fire services including Family and
                Friends
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold mb-2">
                Ambulance With Live Tracking
              </div>
              <p className="text-sm">
                Book Ambulance with GPS live tracking instantly.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold mb-2">
                Medical Digital Vault
              </div>
              <p className="text-sm">
                Secure storage for medical reports, prescriptions, and health
                summaries.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold mb-2">
                Partner Discounts
              </div>
              <p className="text-sm">
                Access discounted services from hospitals, labs, pharmacies, and
                wellness centres via GPS.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold mb-2">
                Preventive Wellness Access
              </div>
              <p className="text-sm">
                Connects to non-invasive services like AcuGraph, Scalar Energy
                Therapy, Power Detox, and more.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold mb-2">
                AI Health Insights
              </div>
              <p className="text-sm">
                Track biological age, vascular health, and receive predictive
                alerts. (Coming Soon)
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold mb-2">
                Single User Per Package/kit
              </div>
              <p className="text-sm">
                Each Package/kit is tied to an individual and mobile number—no
                group or family Package/kit.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold mb-2">
                Corporate Bookings
              </div>
              <p className="text-sm">
                Ideal for organizations offering wellness and emergency
                readiness for employees.
              </p>
            </div>
          </div>
        </section>

        {/* Channel Partner Hierarchy Section */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
            Channel Partner Hierarchy
          </h2>
          <p className="text-center text-gray-600 mb-6">
            Join at a level that suits your reach and resources. Take up
            multiple roles and locations across districts, states, or the entire
            country.
          </p>
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-[#35A93E] text-white">
                  <th className="p-4">Level</th>
                  <th className="p-4">Coverage Area</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="p-4">Country Partner</td>
                  <td className="p-4">Entire India</td>
                </tr>
                <tr className="border-b">
                  <td className="p-4">State Partner</td>
                  <td className="p-4">Specific Indian State</td>
                </tr>
                <tr className="border-b">
                  <td className="p-4">District Partner</td>
                  <td className="p-4">Metro or Non-Metro District</td>
                </tr>
                <tr className="border-b">
                  <td className="p-4">Pincode Partner</td>
                  <td className="p-4">Hyperlocal Area (Urban/Rural)</td>
                </tr>
                <tr>
                  <td className="p-4">Retail Partner</td>
                  <td className="p-4">
                    Individual Point-of-Sale (Local Level)
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Why Partner Section */}
        <section className="bg-white rounded-2xl shadow-xl p-8 mb-10">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
            Why Partner with LifeOnPlus?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-xl font-semibold text-[#35A93E] mb-2">
                Exclusive Sales Rights
              </div>
              <p className="text-gray-600 text-sm">
                Secure exclusive sales rights in your designated area.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold text-[#35A93E] mb-2">
                High-Potential Market
              </div>
              <p className="text-gray-600 text-sm">
                Benefit from a first-mover advantage in a high-growth market.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold text-[#35A93E] mb-2">
                Ongoing Renewal Revenues
              </div>
              <p className="text-gray-600 text-sm">
                Earn continuous revenue from renewals.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold text-[#35A93E] mb-2">
                No Fulfilment Burden
              </div>
              <p className="text-gray-600 text-sm">
                We handle service delivery, so you focus on sales.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold text-[#35A93E] mb-2">
                Marketing & Training Support
              </div>
              <p className="text-gray-600 text-sm">
                Receive marketing kits, training, and digital support.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold text-[#35A93E] mb-2">
                Lead Generation
              </div>
              <p className="text-gray-600 text-sm">
                Get leads via the LifeOnPlus app and website.
              </p>
            </div>
            <div className="text-center">
              <div className="text-xl font-semibold text-[#35A93E] mb-2">
                Flexible Engagement
              </div>
              <p className="text-gray-600 text-sm">
                Choose your scale and region to suit your resources.
              </p>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
            How It Works
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl font-bold text-[#35A93E] mb-3">1</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                Sign Up
              </h3>
              <p className="text-gray-600">
                Register as a channel partner on www.lifeonplus.in.
              </p>
            </div>
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl font-bold text-[#35A93E] mb-3">2</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                Choose Your Role
              </h3>
              <p className="text-gray-600">
                Select your region and partner level (Country, State, District,
                Pincode, or Retail).
              </p>
            </div>
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl font-bold text-[#35A93E] mb-3">3</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                Start Distributing
              </h3>
              <p className="text-gray-600">
                Receive training and marketing kits, then distribute the Smart
                Card in your area.
              </p>
            </div>
            <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="text-4xl font-bold text-[#35A93E] mb-3">4</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                Earn Revenue
              </h3>
              <p className="text-gray-600">
                Generate income from every sale and renewal in your network.
              </p>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Join the Digital Health Revolution
          </h2>
          <p className="text-gray-600 mb-6 max-w-xl mx-auto">
            Whether you're a healthcare provider, entrepreneur, or business
            leader, LifeOnPlus offers you the platform to transform healthcare
            accessibility across India.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              onClick={() =>
                navigate("/", { state: { openChannelPartnerSignUp: true } })
              }
              className="bg-[#35A93E] text-white font-semibold px-8 py-3 rounded-full hover:bg-green-700 transition-colors duration-300"
            >
              Sign Up Now
            </a>
            <a
              href="contact"
              className="bg-white text-[#35A93E] font-semibold px-8 py-3 rounded-full border border-[#35A93E] hover:bg-gray-100 transition-colors duration-300"
            >
              Contact Us
            </a>
          </div>
          <p className="text-gray-600 mt-4 text-sm">
            <div className="flex justify-center gap-2">
              <p>For queries: </p>
              <a
                href="mailto:partners@lifeonplus.in"
                className="text-[#35A93E] hover:underline"
              >
                partners@lifeonplus.com
              </a>{" "}
              <p>| Support Line:</p>{" "}
              <div className="flex">
                <FaWhatsapp className="text-base mt-0.5 text-[#35A93E]" />
                <a
                  href="tel:9986880000"
                  className="text-sm hover:text-[#35A93E]"
                >
                  99868 80000
                </a>
              </div>
            </div>
          </p>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-[#35A93E] to-green-600 text-white py-6">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">© 2025 LifeOnPlus. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default ChannelPartner;
